import { useState, useRef, useCallback, useEffect } from "react";

export function useSearch(searchArticles, debounceMs = 300) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState(null);
  const timeoutRef = useRef(null);
  const requestRef = useRef(0);

  const handleSearch = useCallback((newQuery) => {
    const requestId = ++requestRef.current;
    setQuery(newQuery);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (!newQuery || newQuery.length < 2) {
      setResults(null);
      return;
    }
    timeoutRef.current = setTimeout(async () => {
      const data = await searchArticles(newQuery);
      if (requestRef.current === requestId && data) setResults(data);
    }, debounceMs);
  }, [searchArticles, debounceMs]);

  useEffect(() => () => {
    requestRef.current += 1;
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, []);

  return { query, results, handleSearch };
}

export function filterArticles(articles, activeSource) {
  return articles.filter((a) => {
    const sourceMatch = activeSource === "all" || a.source === activeSource || a.original_articles?.some((original) => original.source === activeSource);
    return sourceMatch;
  });
}

export function sortByPublishedDesc(articles) {
  return [...articles].sort(
    (a, b) => new Date(b.published_at) - new Date(a.published_at)
  );
}
